export default __webpack_public_path__ + "static/media/Spectra_logo_horz.b606dab6.png";